// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.palette-instruments-container {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 17px;
  z-index: 0;
  pointer-events: auto;
}

.gradient-instrument-column {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  z-index: 0;
  pointer-events: auto;
}


.saved-colors-palette-container {
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 10px;
  z-index: 0;
  pointer-events: auto;
}

.saved-colors-palette-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  z-index: 0;
  pointer-events: auto;
}

.saved-colors-palette-color {
  width: 30px;
  height: 30px;
  border-radius: 35%;
  cursor: pointer;
  pointer-events: auto;
}

.controls-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start; 
  transform: translate(-1px);

}

.top-controls {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start; 
}

.bottom-controls {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start; 

}

.saved-add-color {
  width: 30px;
  height: 30px;
  background-color: #BBBBBB66;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 35%;
  pointer-events: auto;
  color: rgb(0, 0, 0);
}

.premium-grayscale-switch {
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  pointer-events: auto;
}

.gradient-color-switch {
  width: 69px;
  height: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  pointer-events: auto;
  transform: translate(-1px, -5px);
  transition: 0.1s ease;

}

.gradient-color-switch.gradient-on {
  height: 34px;
  border-radius: 17px;

  box-shadow: 0 0 0 2px var(--tg-theme-button-color);
  transform: translate(-1px);
  transition: 0.1s ease;

}

.gradient-main-view {
  width: 190px;
  height: 36px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;

  border-radius: 18px;
  transition: 0.1s ease;
  box-shadow: 0 0 0 2px var(--tg-theme-button-color);
  transform: translate(0, 0px);
}

.saved-icon {
  width: 30px;
  height: 30px;
  fill: currentColor;
}

.gradient-ok-button {
  width: 65px;
  height: 38px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);

  font-size: 16px;
  border: none;

  border-radius: 15px;
  pointer-events: auto;
  transform: translate(0, 0px);

  opacity: 0.8;
}

.gradient-ok-button:hover {
  opacity: 0.75;
}
`, "",{"version":3,"sources":["webpack://./src/components/board/tools/Palette/PaletteInstruments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,0BAA0B;;AAE5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;;AAE7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;;AAEvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;;EAEnB,kDAAkD;EAClD,0BAA0B;EAC1B,qBAAqB;;AAEvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;;EAEpB,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,8CAA8C;EAC9C,wCAAwC;;EAExC,eAAe;EACf,YAAY;;EAEZ,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;;EAE5B,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".palette-instruments-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-end;\r\n  gap: 17px;\r\n  z-index: 0;\r\n  pointer-events: auto;\r\n}\r\n\r\n.gradient-instrument-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 10px;\r\n  z-index: 0;\r\n  pointer-events: auto;\r\n}\r\n\r\n\r\n.saved-colors-palette-container {\r\n  display: flex;\r\n  flex-direction: column-reverse;\r\n  justify-content: flex-start;\r\n  align-items: flex-end;\r\n  gap: 10px;\r\n  z-index: 0;\r\n  pointer-events: auto;\r\n}\r\n\r\n.saved-colors-palette-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 10px;\r\n  z-index: 0;\r\n  pointer-events: auto;\r\n}\r\n\r\n.saved-colors-palette-color {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 35%;\r\n  cursor: pointer;\r\n  pointer-events: auto;\r\n}\r\n\r\n.controls-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  align-items: flex-start; \r\n  transform: translate(-1px);\r\n\r\n}\r\n\r\n.top-controls {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n  justify-content: flex-start; \r\n}\r\n\r\n.bottom-controls {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n  justify-content: flex-start; \r\n\r\n}\r\n\r\n.saved-add-color {\r\n  width: 30px;\r\n  height: 30px;\r\n  background-color: #BBBBBB66;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 35%;\r\n  pointer-events: auto;\r\n  color: rgb(0, 0, 0);\r\n}\r\n\r\n.premium-grayscale-switch {\r\n  width: 30px;\r\n  height: 30px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  pointer-events: auto;\r\n}\r\n\r\n.gradient-color-switch {\r\n  width: 69px;\r\n  height: 25px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 12px;\r\n  pointer-events: auto;\r\n  transform: translate(-1px, -5px);\r\n  transition: 0.1s ease;\r\n\r\n}\r\n\r\n.gradient-color-switch.gradient-on {\r\n  height: 34px;\r\n  border-radius: 17px;\r\n\r\n  box-shadow: 0 0 0 2px var(--tg-theme-button-color);\r\n  transform: translate(-1px);\r\n  transition: 0.1s ease;\r\n\r\n}\r\n\r\n.gradient-main-view {\r\n  width: 190px;\r\n  height: 36px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  pointer-events: auto;\r\n\r\n  border-radius: 18px;\r\n  transition: 0.1s ease;\r\n  box-shadow: 0 0 0 2px var(--tg-theme-button-color);\r\n  transform: translate(0, 0px);\r\n}\r\n\r\n.saved-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  fill: currentColor;\r\n}\r\n\r\n.gradient-ok-button {\r\n  width: 65px;\r\n  height: 38px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  background-color: var(--tg-theme-button-color);\r\n  color: var(--tg-theme-button-text-color);\r\n\r\n  font-size: 16px;\r\n  border: none;\r\n\r\n  border-radius: 15px;\r\n  pointer-events: auto;\r\n  transform: translate(0, 0px);\r\n\r\n  opacity: 0.8;\r\n}\r\n\r\n.gradient-ok-button:hover {\r\n  opacity: 0.75;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
